module.exports = __webpack_public_path__ + "static/media/Composant2.ffd61531.png";